const ShortRoutes = {
  create: "shortcodes/create",
  getShortCode: "shortcodes",
  getCategory: "shortcodes/categories",
  deleteShortCode: "shortcodes/delete/",
  updatedShortCode: "shortcodes/update",
};

export default ShortRoutes